import { api } from "../../common/api/index.ts";
import { loadPresentations } from "../store/topics.ts";

const doGetTopics = api.path("/api/presentation").method("get").create();

export async function getTopics() {
	try {
		const response = await doGetTopics({});

		const topics = response.data;
		loadPresentations(topics);
	} catch {
		loadPresentations([]);
	}
}
